import { ChangeDetectionStrategy, Component } from "@angular/core";
import { StringHelper } from "../../../utilities/contracts/string-helper";
import { DynamicControlComponent } from "../../dynamic-control-component.model";
import { SelectableInput } from "../selectable-input.model";
import { Radiobutton } from "./radiobutton.model";

@Component({
  selector: "form-radiobutton",
  templateUrl: "./radiobutton.component.html",
  styleUrls: ["./radiobutton.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadiobuttonComponent extends DynamicControlComponent<Radiobutton> {

  get groupName(): string {
    return this.model.name;
  }

  get options(): SelectableInput[] {
    return this.model.options;
  }

  get hasLabel(): boolean {
    return StringHelper.isAvailable(this.model.label);
  }

  onChangeEvent(event: MouseEvent, option: SelectableInput): void {
    event.preventDefault();
    event.stopPropagation();

    // FIXME: The emit should not need `as any` but it does. Please fix!
    this.onChange.emit(option.value as any);
    this.onInput.emit(option.value as any);
  }

  get classes(): string {
    return this.getClasses("radiobutton");
  }

  get hasSubLabel(): boolean {
    return StringHelper.isAvailable(this.model.subLabel);
  }

  trackByIndex(index, item) {
    return index;
  }
}
